import {FormWrapper} from "../../../../components/form-wrapper";
import {useGetEditableSubscriptionContext} from "../context/get-editable-subscription";
import {SubscriptionCoverImagesBlock} from "../../subscription-cover-images-block";

export function EditSubscriptionCoverImagesForm() {
  const {
    state: {subscriptionData},
  } = useGetEditableSubscriptionContext();

  const subscriptionId = subscriptionData.productSubscription.id;

  return (
    <FormWrapper borderless>
      <SubscriptionCoverImagesBlock
        subscriptionId={subscriptionId}
        fallbackProductSubscription={subscriptionData.productSubscription}
      />
    </FormWrapper>
  );
}
